import { useSettingsStore } from '../store/settings';

export const removerChavesObjeto = (obj, chaves) => {
  const newObj = Object.entries(obj)
    .filter(entry => !chaves.includes(entry[0]))
    .reduce((acc, keyValue) => ({ ...acc, [keyValue[0]]: keyValue[1] }), {});
  return newObj;
};

export const getQueryParams = () => {
  const urlParams = window.location.search.slice(1).split('&');
  const params = {};

  urlParams.forEach(param => {
    const values = param.split('=');
    values.length > 1
      ? (params[values[0]] = values[1])
      : (params[values[0]] = true);
  });

  return params;
};

export const isFix = () => {
  const urlParams = window.location.search.slice(1).split('&');
  const { hasPendingCachedImages } = useSettingsStore.getState();

  return (
    urlParams.includes('fix') ||
    (hasPendingCachedImages &&
      urlParams?.[0]?.includes('itemId=') &&
      !urlParams.includes('view') &&
      !urlParams.includes('print'))
  );
};

export const isViewMode = () => {
  const urlParams = window.location.search.slice(1).split('&');
  const { isAppFinished, hasPendingCachedImages } = useSettingsStore.getState();

  return (
    urlParams.includes('view') ||
    (isAppFinished && !hasPendingCachedImages &&
      urlParams?.[0]?.includes('itemId=') &&
      !urlParams.includes('fix') &&
      !urlParams.includes('print'))
  );
};

export const isAppEnabled = () => {
  if (isViewMode() || isFix()) {
    return useSettingsStore.getState().isAppEnabled;
  }
  return true;
};

export const isMetadataUrl = (url) => {
  const regex = /api\/items\/.+\/metadata/;
  return regex.test(url);
};

export const isDeepEqual = (obj1, obj2) => {
  if (obj1 != null && obj1 === obj2) return true;

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key) || !isDeepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};

export const normalizeLogError = (error, errorInfo) => {
  const safeStringify = e => {
    if (e == null) return null;
    if (typeof e === 'string') return e;

    const parts = {};
    if (e.name) parts.name = e.name;
    if (e.message) parts.message = e.message;
    if (e.stack) parts.stack = e.stack;
    if (e.code) parts.code = e.code;

    const status = e.status || e.response?.status;
    const data = e.data || e.response?.data;
    if (status != null) parts.status = status;
    if (data != null) parts.data = data;

    if (e.config?.url) parts.url = e.config.url;
    if (e.config?.method) parts.method = e.config.method;

    if (Object.keys(parts).length > 0) return JSON.stringify(parts);

    try {
      const raw = JSON.stringify(e);
      if (raw && raw !== '{}') return raw;
    } catch { }

    return null;
  };

  const result = {
    error: safeStringify(error) || 'Erro vazio ou indefinido',
    errorMessage: error?.message || 'Sem mensagem',
    errorStatus: error?.status || error?.response?.status || 'Sem status',
    errorData: error?.data || error?.response?.data || 'Sem dados'
  };

  if (errorInfo != null) result.errorInfo = errorInfo;

  return result;
};